import TrackerManager from './trackerManager';
import { ListDisplayType } from '../../containers/DriveItemList/constants';
import { RoutePath,
	RouteParams, RouteParamsTheater, RouteParamsDriveItemDetailPage, RouteParamsDriveItemListPage, RouteParamsStaticPage, RouteParamsEditor } from '../../routes/constants';
import { DriveItemListOrigin } from '../../containers/DriveItemListPage/constants';
import { Api } from '../../typings/api';
import UserAgentUtils from '../userAgent';
import Utils from '../';
import DriveItemUtils from '../driveItem';

class StatsUtils {
	private static lastTrackedHash: string;
	public static updateConfig(config: string) {
		const trackerManager = TrackerManager.getInstance();
		const galleryCredentials = Utils.getGalleryCredentials();
		trackerManager.updateConfig(config, UserAgentUtils.isMobileApp, galleryCredentials ? galleryCredentials : undefined);
	}

	public static trackPageView(route: RoutePath, params: RouteParams) {
		const url = window.location.hash;
		if (StatsUtils.lastTrackedHash === url) {
			return;
		}
		const statsTitle = StatsUtils.getStatsTitle(route, params);

		const trackerManager = TrackerManager.getInstance();
		trackerManager.trackEvent('navigation', 'open', statsTitle);
		trackerManager.trackPage('page', url, statsTitle);

		StatsUtils.lastTrackedHash = url;
	}

	public static trackDisplayType(displayType: ListDisplayType) {
		const trackerManager = TrackerManager.getInstance();
		trackerManager.trackEvent('navigation', `viewMode - ${displayType}`, `change view mode to ${displayType}`);
	}

	public static trackView(driveItem: Api.DriveItem) {
		const trackerManager = TrackerManager.getInstance();
		const viewedAsset = StatsUtils.getDriveItemInfos(driveItem);
		trackerManager.trackEvent('view', `view - ${viewedAsset}`, `view the asset : ${viewedAsset}`);
	}

	public static trackShare(driveItems: Api.DriveItem[]) {
		const trackerManager = TrackerManager.getInstance();
		const splittedSharedAssets = StatsUtils.getSplittedDriveItemsInfos(driveItems);
		splittedSharedAssets.map(sharedAssets => {
			trackerManager.trackEvent('share', `share - ${sharedAssets}`, `share the assets : ${sharedAssets}`);
		});
	}

	public static trackDownload(driveItems: Api.DriveItem[]) {
		const trackerManager = TrackerManager.getInstance();
		const splittedDownloadedAssets = StatsUtils.getSplittedDriveItemsInfos(driveItems);
		splittedDownloadedAssets.map(downloadedAssets => {
			trackerManager.trackEvent('download', `download - ${downloadedAssets}`, `download the assets : ${downloadedAssets}`);
		});
	}

	public static trackDownloadAll() {
		const trackerManager = TrackerManager.getInstance();
		trackerManager.trackEvent('download', `download - all`, `download all assets`);
	}

	// All RoutePath must be in the switch, do not add a default case
	private static getStatsTitle(route: RoutePath, params: RouteParams): string {
		let castedParams;
		switch (route) {
			case RoutePath.Default:
				return `Home Page`;
			case RoutePath.Home:
				return `Home Page`;
			case RoutePath.Authentication:
				return `Authentication Page`;
			case RoutePath.ParametersPage:
				return `Parameters Page`;
			case RoutePath.ProfilePage:
				return `Profile Page`;
			case RoutePath.ProposalStatsPage:
				return `My sent Page`;
			case RoutePath.DriveItemListPage:
				castedParams = params as RouteParamsDriveItemListPage;
				return StatsUtils.getDriveItemListPageTitle(castedParams);
			case RoutePath.TheaterList:
			case RoutePath.Theater:
				castedParams = params as RouteParamsTheater;
				return `Theater Page - ${castedParams.driveItemId}`;
			case RoutePath.DriveItemDetailPage:
				castedParams = params as RouteParamsDriveItemDetailPage;
				return `Detail Page - ${castedParams.driveItemId}`;
			case RoutePath.NotFound:
				return `Page not found`;
			case RoutePath.StaticPage:
				castedParams = params as RouteParamsStaticPage;
				return `Page - ${castedParams.component}`;
			case RoutePath.Editor:
				castedParams = params as RouteParamsEditor;
				return `Editor - ${castedParams.clientId} - ${castedParams.resourceId}`;
		}
	}

	private static getDriveItemListPageTitle(params: RouteParamsDriveItemListPage): string {
		const origin: DriveItemListOrigin = params.origin;
		switch (origin) {
			case DriveItemListOrigin.Downloads:
				return `Download Page`;
			case DriveItemListOrigin.Selection:
				return `Selection Page`;
			case DriveItemListOrigin.Folder: {
				if (!params.originParam) {
					return `Gallery Page`;
				}
				return `Folder Page - ${params.originParam}`;
			}
			case DriveItemListOrigin.New:
				return `New Page`;
			case DriveItemListOrigin.Search:
				return `Search Page - ${params.originParam}`;
			case DriveItemListOrigin.Assortment:
				return `Assortment Page - ${params.originParam}`;
		}
	}

	private static getSplittedDriveItemsInfos(driveItems: Api.DriveItem[]): string[] {
		/*
			Google analytics has a limit for event's parameters's length.
			For this reason we split the driveItemInfos so that it doesn't reach this limit.
		*/
		const maxEventLabelLength = 500; // Google analytics's limit for action & label is 500 bytes
		const reservedLength = 50; // we reserve 50 chars for the constant part of the event action/label
		const maxSplitLength = maxEventLabelLength - reservedLength;
		const separator = ',';

		let splits = [''];
		let currentSplitIndex = 0;
		let currentSplitLength = 0;
		for (let i = 0; i < driveItems.length; i++) {
			const driveItem = driveItems[i];

			const driveItemInfo = `${StatsUtils.getDriveItemInfos(driveItem)}${separator}`;
			const driveItemInfoLength = encodeURIComponent(driveItemInfo).length;
			currentSplitLength += driveItemInfoLength;

			if (currentSplitLength < maxSplitLength) {
				splits[currentSplitIndex] += driveItemInfo;
			} else {
				currentSplitIndex++;
				splits[currentSplitIndex] = driveItemInfo;
				currentSplitLength = driveItemInfoLength;
			}
		}
		return splits;
	}

	private static getDriveItemInfos(driveItem: Api.DriveItem): string {
		return `${DriveItemUtils.getDisplayName(driveItem)}-${driveItem.id}`;
	}
}

export default StatsUtils;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/statistics/index.ts